import { UserCharge, UserInvoice } from "@providers/profile/ProfileProvider.model";
import { Shopify } from "@models/shopify.model";
import { ProductModal } from "@models/product-globals.model";
import { PaymentHistoryDisclaimers } from "@models/user-account-globals";
import { Sanity } from "@models/sanity.model";

export interface PaymentState {
  loading: boolean;
  displayOrderDetail: Shopify.Order | null;
  orders: Shopify.Order[];
  invoices: UserInvoice[];
  charges: UserCharge[];
}

export const initialPaymentState = {
  loading: false,
  displayOrderDetail: null,
  orders: [] as Shopify.Order[],
  invoices: [] as UserInvoice[],
  charges: [] as UserCharge[],
};

export interface PaymentListProps {
  isDigital: boolean;
  digitalDisclaimer?: string;
  invoices: UserInvoice[];
  orders: Shopify.Order[];
  toggleOrderDetails: (order: Shopify.Order | null) => void;
}

export interface PaymentStatusProps {
  isDigital: boolean;
  digitalDisclaimer?: Sanity.PortableText;
  charges: UserCharge[];
}

export interface OrderDetailProps {
  order: Shopify.Order;
  membershipModal: ProductModal;
  toggleOrderDetails: (order: Shopify.Order | null) => void;
}

export interface PaymentHistoryProps {
  isDigital: boolean;
  membershipModal: ProductModal;
  digitalDisclaimers?: PaymentHistoryDisclaimers;
}
